import UserProfilesApi from '@/api/userProfiles/';

export default {
    state: {
        userInfo: {},
        
    },
    mutations: {
    	setUserInfo(state, info) {
    	    state.userInfo = info
    	}
    },
    getters: {
        // messageUnreadCount: state => state.messageUnreadList.length,
        // messageReadedCount: state => state.messageReadedList.length,
        // messageTrashCount: state => state.messageTrashList.length
    },
    actions: {
        // 获取用户相关信息
        getUserProfilesInfo({ state, commit }, userOpt) {
            return new Promise((resolve, reject) => {
                try {
                    //获取个人主页t用户基础消息
					// let userOpt = {user_id: 15493, user_type: 'user'}
                    UserProfilesApi.getUserInfo(userOpt).then(data => {
                        if(!data) return false
                        if(!data.image){
                            data.image = data.avatar
                        }
                        commit('setUserInfo', data)
                        resolve(data)
                    }).catch(err => {
                        reject(err)
                    })
                } catch (error) {
                    reject(error)
                }
            })
        },
       
    }
}